import { FormControl, Switch } from '@mui/material';
import styled from 'styled-components';
import { media } from '../../theme/breakpoints';
import theme from '../../theme/theme';

export const ChatContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-height: 750px;
    width: 100%;
`;

export const StyledFormControl = styled(FormControl)`
    && {
        .MuiSelect-select {
            padding: 12px;
        }

        .MuiOutlinedInput-root {
            border-radius: 8px;
            border-color: #a7b2bc;
        }

        .MuiOutlinedInput-notchedOutline {
            border-color: #a7b2bc;
        }

    }
`;

export const ChatWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const ChatCard = styled.div<{ $isEmpty?: boolean }>`
    display: flex;
    flex-direction: column;
    height: 750px;
    padding: 20px;
    border-radius: 40px;
    background-color: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
    border: 1px solid rgba(224, 224, 224, 1);
    width: 100%;

    @media (min-width: 1200px) {
        width: 740px;
    }
`;

export const SelectsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;

    ${media.tablet} {
        flex-direction: row;
        gap: 0;
        width: auto;
    }
`;

export const HeaderActions = styled.div`
    text-align: right;
    margin-bottom: 10px;

    ${media.sm} {
        margin-bottom: 10px;
    }
`;

export const LogoWrapper = styled.div`
    text-align: center;

    img {
        width: 280px;
        height: auto;
    }
`;

export const ChatHeader = styled.div<{ $isBigSpace: boolean }>`
    font-weight: 700;
    font-size: 20px;
    margin-bottom: ${(props) => (props.$isBigSpace ? '40px' : '20px')};
    margin-top: ${(props) => (props.$isBigSpace ? '16px' : '0')};

    ${media.sm} {
        font-size: 22px;
    }

    ${media.md} {
        font-size: 25px;
    }
`;

export const TopBarContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    margin-bottom: 20px;
    gap: 12px;

    ${media.tablet} {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 0;
    }
`;

export const SelectTopics = styled.div`
    margin-bottom: 20px;
    width: 100%;
`;

export const UseDocumentsWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 17px;
    margin-top: 12px;
    margin-bottom: 24px;
`

export const StyledSwitch = styled(Switch)({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: theme.palette.primary.main,
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
    },
    '& .MuiSwitch-track': {
        backgroundColor: '#A7B2BC',
    },
});

export const CenterContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
`;
